import React from "react";
import { useRetrieveCurrentPlanzone } from "@planzone/view-models";
import { SecondaryCriteriaTemplate } from "@scenes/secondaryCriteriaTemplate";
import styles from "./styles.scss";

function SecondaryCriteriaTemplatePage() {
  const { planzone } = useRetrieveCurrentPlanzone();

  return (
    <div className={styles.secondaryCriteriaTemplatePage}>
      <SecondaryCriteriaTemplate namespace={planzone.uuid} scope="planzone" />
    </div>
  );
}

export { SecondaryCriteriaTemplatePage };
